module.exports = __webpack_public_path__ + "static/media/capital-one.9056c79c.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/capital-one.png
// module id = 7369
// module chunks = 4